import { Tooltip } from 'app/components/BasicTooltips/Tooltip';
import { useTranslation } from 'react-i18next';
import * as React from 'react';
import { IRow } from 'app/components/BasicTable/IRow';
import { Link as MuiLink } from '@material-ui/core';
import { translations } from 'locales/translations';
import { RenderPageType } from 'app/Layout/FrontendLayout/slice/type';
import { AssetIdentifier } from 'app/pages/AssetPopUp/components/Utils';
import useSidePanelState, {
  SidePanelOpenState,
} from 'app/hooks/useSidePanelOpen';
import { PrimaryActionDynamic } from 'app/components/BasicTable/components/TableCard/PrimaryAction';
import { ServiceTypeUnion } from 'enums/ServiceTypes';
import { Row } from 'react-table';
import { AssetPopUpProps } from 'app/pages/AssetPopUp/index';
import { pick } from 'lodash';

interface AssetLinkIdentifierProps {
  id?: number;
  serviceId?: number;
  serviceType?: ServiceTypeUnion;
}
export type AssetLinkProps = AssetIdentifier & {
  children: React.ReactNode;
  title?: string;
  useSidePanel?: boolean;
  openPanelWithCover?: (state: SidePanelOpenState) => void;
};

export const AssetLink = (props: AssetLinkProps) => {
  const { t } = useTranslation();
  const openAsset = useOpenAssetPopUp();

  const open = () => {
    openAsset(
      pick(props, 'id', 'serviceId', 'serviceType') as AssetIdentifier,
      props.openPanelWithCover,
    );
  };
  return (
    <Tooltip title={props.title ?? t(translations.ShowAssetSidePanel)}>
      <MuiLink
        style={{ cursor: 'pointer' }}
        onClick={() => open()}
        color="textPrimary"
      >
        {props.children}
      </MuiLink>
    </Tooltip>
  );
};

export type UseOpenAssetPopUpProps = AssetIdentifier & {
  useSidePanel?: boolean;
};
export const useOpenAssetPopUp = () => {
  const { openPanel } = useSidePanelState();

  return React.useCallback(
    (
      props: UseOpenAssetPopUpProps,
      openPanelWithCover?: (state: SidePanelOpenState) => void,
    ) => {
      const identifier = props;
      if (identifier !== undefined) {
        const assetPopupProps: AssetPopUpProps = {
          identifier: identifier,
          useSidePanel: props.useSidePanel ?? false,
        };
        if (!!openPanelWithCover) {
          openPanelWithCover({
            renderPageType: RenderPageType.AssetDetails,
            renderPageProps: assetPopupProps,
            expanded: false,
            useSidePanel: props.useSidePanel,
            isCover: props.useSidePanel,
          });
        } else {
          openPanel({
            renderPageType: RenderPageType.AssetDetails,
            renderPageProps: assetPopupProps,
            expanded: false,
            useSidePanel: false,
            isCover: false,
          } as SidePanelOpenState);
        }
      }
    },
    [openPanel],
  );
};

interface PrimaryActionDynamicRow extends IRow {
  Id?: number;
  serviceId?: number;
  serviceType?: ServiceTypeUnion;
}

//used for Dashboard tadles
export const OpenAssetPrimaryAction: PrimaryActionDynamic<PrimaryActionDynamicRow> = (
  openPanel,
  row,
  toggle,
  user,
  useSidePanel,
) => {
  const identifier = getAssetIdentifier(row);
  if (identifier === undefined) {
    console.error('no asset identifier found for row ', row);
  } else {
    const props: AssetPopUpProps = {
      identifier: identifier,
      useSidePanel: useSidePanel ?? false,
    };
    openPanel({
      renderPageType: RenderPageType.AssetDetails,
      renderPageProps: props,
      useSidePanel: useSidePanel,
      expanded: false,
      isCover: useSidePanel,
    });
  }
};
function getAssetIdentifier(
  row: Row<PrimaryActionDynamicRow>,
): AssetIdentifier | undefined {
  return getAssetLinkIdentifier({
    id: row.original.Id,
    serviceId: row.original.serviceId,
    serviceType: row.original.serviceType,
  });
}

function getAssetLinkIdentifier(
  row: AssetLinkIdentifierProps,
): AssetIdentifier | undefined {
  if (row.id !== undefined) {
    return {
      id: row.id,
    };
  } else if (row.serviceId !== undefined && row.serviceType !== undefined) {
    return {
      serviceId: row.serviceId,
      serviceType: row.serviceType,
    };
  }
}
